import React, { useEffect, useState } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import useSkeleton from "../hooks/useSkeleton.jsx";
import { setImageCache, getCachedImage, hasCachedImage } from "./imageCache.js";
import useHelpers from "../hooks/useHelpers.jsx";

const CardImageAndBody = (props) => {
  const { card, href, isRoomOrApartment } = props;
  const imageID = isRoomOrApartment(card)
    ? card.address + "-apartment"
    : card.address + "-property";

  const { translate, translatei18nDB, constructApartmentName } =
    tampuuriWindowObject();

  const { getApartmentImage, getCostUnitImage } = useHelpers();
  const [imageSrc, setImageSrc] = useState("");
  const [state, setState] = useState({});

  const { dummyImage } = useSkeleton();

  useEffect(() => {
    if (hasCachedImage(imageID)) {
      // Has already an image
      setImageSrc(getCachedImage(imageID));
    }

    handleImageLoad();
  }, [card]);

  const handleImageLoad = () => {
    setState({ loadingImage: true });

    const promise = isRoomOrApartment(card)
      ? getApartmentImage(card)
      : getCostUnitImage(card);

    promise
      .then((url) => {
        if (url) {
          setImageSrc(url);
          setImageCache(imageID, url);
        }
      })
      .catch((e) => {
        setState({ error: e });
      })
      .finally(() => {
        setState({ loadingImage: false });
      });
  };

  const getCostUnitPriceLevel = () => {
    return card?.price_level ? card.price_level : "Matala";
  };

  const getCostUnitRentRange = () => {
    const { min_rent, max_rent } = card?.rents?.costunit ?? {};
    const hasMinRent =
      min_rent !== undefined && min_rent !== null && min_rent !== "";
    const hasMaxRent =
      max_rent !== undefined && max_rent !== null && max_rent !== "";

    if (!hasMinRent || !hasMaxRent) {
      return "";
    }

    if (String(min_rent) === String(max_rent)) {
      return `(${min_rent} €)`;
    }

    return `(${min_rent} € - ${max_rent} €)`;
  };

  return (
    <a href={href} className="d-block">
      <div className="card-container-flex">
        <div className="content">
          {isRoomOrApartment(card) ? (
            <h3 className="type-h4">{constructApartmentName(card?.name)}</h3>
          ) : (
            <h3 className="type-h4">{card?.address}</h3>
          )}

          <p>
            {card?.quarter_of_town != null && card?.quarter_of_town + ", "}
            {card?.city}
          </p>

          {isRoomOrApartment(card) ? (
            <>
              <p>
                {card?.apartment_type}
                {card?.surface_area && ", " + card?.surface_area + " m²"}
              </p>
              <p>
                {card?.rent != null &&
                  card?.rent > 0 &&
                  translate("Vuokra") + ": " + card?.rent + " €"}
              </p>
            </>
          ) : (
            <>
              <p>
                {translate("Hintataso")}: {translate(getCostUnitPriceLevel())}{" "}
                {getCostUnitRentRange()}
              </p>
              {card?.condition && (
                <p>
                  {translate("Condition")}: {translate(card?.condition)}
                </p>
              )}
              {card?.apartment_categories && (
                <p>
                  {translate("Asuntotyypit")}:{" "}
                  {card?.apartment_categories.map((f, index) => {
                    if (f) {
                      return index < card.apartment_categories.length - 1
                        ? translatei18nDB(f) + ", "
                        : translatei18nDB(f);
                    }
                  })}
                </p>
              )}
            </>
          )}
        </div>

        {state?.loadingImage ? (
          dummyImage(imageID)
        ) : (
          <div className="image-container">
            <img
              id={imageID}
              className="responsive-image img-fluid lazyautosizes lazyloaded"
              loading="lazy"
              src={imageSrc}
              alt={translate("Alternate image of") + " " + card?.address}
            />
          </div>
        )}
      </div>
    </a>
  );
};

export default CardImageAndBody;
